import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { log } from '../utils/logger';

export default function RequireAuth({ children }: { children: ReactNode }) {
  const { user, authReady } = useAuth();
  const location = useLocation();

  // Still loading authentication state
  if (!authReady) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated - redirect to login
  if (!user) {
    log.info('auth_required_redirect', {
      message: `Unauthenticated user redirected to login from: ${location.pathname}`,
      path: location.pathname
    });
    
    const dest = `/login${location.search}`;
    return <Navigate to={dest} state={{ from: location.pathname + location.search }} replace />;
  }

  return <>{children}</>;
}

